import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StepIndicator from "./StepIndicator";
import { useLocation } from "react-router-dom";
import { useContent } from "../context/ContentProvider";
import { useBooking } from "../context/BookingContext";

const Layout: React.FC = () => {
  const { content } = useContent();
  const { isEmbedded, currentStep } = useBooking();
  const location = useLocation();
  const path = location.pathname;

  // Don't show step indicator on confirmation page, main page, or about page
  const showStepIndicator =
    currentStep !== 5 && path !== "/" && path !== "/about" && path !== "/contact-us";

  // If in iframe mode, show only the booking content
  if (isEmbedded) {
    return (
      <div className="iframe-booking-container">
        {/* Only show step indicator and main content in iframe */}
        {showStepIndicator && <StepIndicator />}
        <Outlet />
      </div>
    );
  }

  // Regular layout for non-iframe mode
  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ backgroundColor: "var(--hotel-background-color)" }}
    >
      {/* Welcome Banner - now using dynamic content */}
      <div className="banner-promo py-3 px-4 text-center shadow-md z-10">
        <p className="text-sm font-medium font-satoshi">
          {content.welcomeTitle || ""}
        </p>
      </div>

      {/* Header */}
      <Header />

      {/* Main content */}
      <main className="">
        {showStepIndicator && <StepIndicator />}
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
